/**
 * Navigation Context.
 *
 * @format *
 */

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { createContext } from 'react';
import { useFetchData } from '@hooks/use-fetch-data';
import { safeLanguageUrlPrefix } from '@services/drupal-services';

/**
 * Navigation Context.
 */
export const NavigationContext = createContext();

/**
 * Navigation Provider.
 *
 * @param {object} props
 */
export const NavigationProvider = (props): JSX.Element => {
  const navigationData = useFetchData(
    `/${safeLanguageUrlPrefix()}rest-api/varian-menu/all?_format=json`
  );
  const { children } = props;
  return (
    <NavigationContext.Provider value={navigationData}>
      {children}
    </NavigationContext.Provider>
  );
};
